export default __webpack_public_path__ + "static/media/check-mark.d085dc25.png";